<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>类型</span>
        </div>
        <div class="conf">
          <el-form-item label="商品类型:" prop="prdType">
            <el-radio-group v-model="self_form.prdType">
              <el-radio :label="0">按SKU</el-radio>
              <el-radio :label="1">按SPU</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>基本信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品名称:" prop="title">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.title"
              :maxlength="50"
            />
            <div style="color: #ccc;font-size:12px;">注意：品名中不要加商家名称、价格、非商品信息（如：活动赠品、推广信息）。<el-link :underline="false" @click="productTitleStandardVisible = true" >商品名称规范</el-link></div>
            <el-table :data="titleExampleData" border style="width: 550px">
              <el-table-column prop="rule" label="命名规则"> </el-table-column>
              <el-table-column prop="brand" label="品牌"> </el-table-column>
              <el-table-column prop="subBrand" label="子品牌"></el-table-column>
              <el-table-column prop="name" label="品名"></el-table-column>
              <el-table-column prop="description" label="商品描述"></el-table-column>
              <el-table-column v-if="self_form.prdType === 0" prop="spec" label="规格/包装单位" width="130"></el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="商家编码:" prop="outerId" v-if="self_form.prdType === 1">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.outerId"
              :maxlength="50"
            />
          </el-form-item>
          <el-form-item label="商品分类:" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" :baseItemId="baseItemId" v-model="self_form.categoryIds" :platform="platform" />
            </div>
          </el-form-item>
          <el-form-item label="商品品牌" prop="brandList">
            <BrandIdBlock
              ref="brandIdBlock"
              :baseItemId="baseItemId"
              :categoryIds="self_form.categoryIds"
              v-model="self_form.brandList"
              :shopList="shopList"
            />
            <!-- <div style="font-size: 12px;color:#ccc;">建议品牌：其他品牌<el-link :underline="false" style="margin-left: 5px;">使用</el-link></div> -->
          </el-form-item>
          <el-form-item 
            label="店内分类" 
            prop="shopCategories"
          >
            <ShopCategories
              ref="shopCategoriesRef"
              :baseItemId="baseItemId"
              :shopList="shopList"
              v-model="self_form.shopCategories"
            />
          </el-form-item>
          <el-form-item v-show="self_form.prdType === 0" label="商品图片" prop="images">
            <div>
                <div style="font-size:12px;color:#ccc;"><span style="color: #ff3333;">*</span>商品展示图(铺货时只取主图，拖动可调整顺序)</div>
                <MutiImgUpload
                    v-model="imagesMap['0000000000']"
                    ref="pic"
                    limitSuffix=".jpg,.jpeg,.png,.webp" 
                    :limitNums="6"
                    :limitWidth="[0, 0]"
                    :limitHeight="[0, 0]"
                    :limitSize="5 * 1024 * 1024"
                    :size="200"
                    :aspectRatio="1"
                    :aspectRatioText="'1:1'"
                    show-audit-result
                    :isCheckImg="false"
                    :supportAiRetry="true"
                />
                <div style="font-size:12px;color:#ccc;">
                  图片至少上传1张，最多6张，大小不超过1M，建议尺寸为800px*800px，仅支持jpg、jpeg、png格式，您可以拖拽图片调整顺序。为避免客诉请不要在商品图片中添加利益点！
                  <!-- <el-link :underline="false" style="margin-left: 5px;">查看图片示例说明</el-link> -->
                </div>
            </div>
          </el-form-item>
          <el-form-item label="无理由标签" prop="returnLabel">
            <el-select v-model="self_form.returnLabel" style="width: 100%;" placeholder="请选择" >
              <el-option v-for="item in returnPropsList" :key="item.key" :label="item.valueName" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>销售信息</span>
        </div>
        <div class="conf" v-if="self_form.prdType === 0">
          <el-form-item label="商品毛重(kg):" prop="weight">
            <el-input-digit v-model="self_form.weight" :precision="4" placeholder="请输入" style="width:120px;" />
            <!-- <el-link :underline="false" style="margin-left: 10px;">说明</el-link> -->
          </el-form-item>
          <el-form-item label="商品价格(元):" prop="price">
            <el-input-digit v-model="self_form.price" :precision="2" placeholder="请输入" style="width:120px;" />
          </el-form-item>
          <el-form-item label="商品条码(UPC):" prop="upcCode">
            <el-input v-model="self_form.upcCode" placeholder="请输入" />
            <!-- <el-link :underline="false" style="margin-left: 10px;">说明</el-link> -->
          </el-form-item>
          <el-form-item label="商品SKU编码:" prop="outerId">
            <el-input v-model="self_form.outerId" placeholder="请输入" />
          </el-form-item>
        </div>
        <div class="conf" v-show="self_form.prdType === 1">
            <el-form-item label="商品规格:" prop="skuAttrs">
              <RuleSortBtn :specifications.sync="specifications" />
              <SpecsValuesSort :specifications.sync="specifications" />
              <JdmsSpecification
                ref="jdmsSpecificationRef"
                v-model="specifications"
                :salePropList="salePropList"
                :changeToBase="changeToBase"
                :isPlatform="true"
                @file-upload="imageUpload"
              />
            </el-form-item>
            <el-form-item label="规格明细:" prop="skuAttrsDetail">
              <FormItemSkuList
                :specifications="specifications"
                skuSpecificationsKey="skuSpecifications"
                skuOuterIdKey="outerSkuId"
                :tableCols="skuTableCols"
                v-model="skuList"
                @fieldChanged="specificationsFieldChanged"
              >     
                <template slot="skuPropHeaderSlot">
                  <span style="color: red" v-if="skuPropList.filter(item=>item.isRequired).length">*</span> SKU属性
                  <div style="height: 24px;line-height: 24px;display: block;padding: 0;"><el-button type="text" @click="editSkuCateprops({}, true)">批量设置</el-button></div>
                </template>
                <template slot="skuPropSlot" slot-scope="{ row }">
                  <el-button type="text" @click="editSkuCateprops(row)">SKU属性</el-button>
                </template>
              </FormItemSkuList>
              <template v-if="specificationsValidResult !== true">
                <div class="el-form-item__error">{{specificationsValidResult}}</div>
              </template>
            </el-form-item>
        </div>
      </section>
      <section v-if="self_form.prdType === 1 && mainSku.length">
        <div class="title ft-12">
          <span>商品图片</span>
        </div>
        <div class="conf">
          <div 
            v-for="skuValue in mainSku"
            :key="skuValue"
          >
            <el-form-item
              :style="skuValue === '0000000000' ?'':'margin-bottom:0'"
              :label="skuValue === '0000000000' ? '商品图片' : skuValue"
            >
              <div style="margin-bottom: 10px" v-if="skuValue === '0000000000'">
                <el-button @click="pushSkuImg">一键追加到所有sku图</el-button>
                <el-button @click="coverSkuImg">一键覆盖到所有SKU图</el-button>
              </div>
              <div style="margin-bottom: 10px" v-if="skuValue !== '0000000000'">
                <el-button @click="applyMainImg(skuValue)">使用商品图片</el-button>
              </div>
              <div>
                <ImageBlock
                  :ref="'IB-' + skuValue"
                  :colorId="skuValue"
                  v-model="imagesMap[skuValue]"
                  :showSettingSearchImgBtn="false"
                  :imagesLength="mainSku.length"
                />
              </div>
            </el-form-item>
          </div>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>商品详情</span>
        </div>
        <div class="conf">
          <el-form-item label="图文详情:" prop="isShowProductDesc">
            <el-radio-group v-model="self_form.isShowProductDesc">
              <el-radio :label="0">对用户不展示</el-radio>
              <el-radio :label="1">对用户展示</el-radio>
            </el-radio-group>
            <Editor 
              id="pc" 
              v-if="self_form.isShowProductDesc === 1"
              :limitImgSize="3 * 1024 * 1024" 
              v-model="self_form.productDesc" 
              @fullScreenChange="editorFullScreenChange" 
              style="width:800px;"
            />
          </el-form-item>
          <el-form-item label="商品广告语:" prop="slogan">
            <el-input type="text" v-model="self_form.slogan" maxLength="45" placeholder="请输入商品宣传广告内容" />
          </el-form-item>
          <el-form-item label="广告语有效期:" prop="sloganTime">
            <el-date-picker
              v-model="self_form.sloganTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="特殊属性:" prop="categorySpecAttrs" v-if="specAttrList.length">
            <div class="flex">
              <span style="color: #606266;font-size:12px;">加工服务：</span>
              <el-checkbox-group class="flex-1" v-model="specAttrCheckList">
                <el-checkbox v-for="item in specAttrList" :key="item.key" :label="item.key">{{item.valueName}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="类目属性:" prop="categoryAttrs">
            <Attributes v-if="attributeList && attributeList.length" ref="attributesRef" :formData="self_form" :attrList="attributeList" />
          </el-form-item>
          <el-form-item label="注册批准日期:" prop="approvalTime">
            <el-date-picker
              v-model="self_form.approvalTime"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="注册截止日期:" prop="approvalEndTime">
            <el-date-picker
              v-model="self_form.approvalEndTime"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="注册资格证:" prop="registImage">
            <MutiImgUpload
                v-model="self_form.registImage"
                ref="registPic"
                :mainImgNums="0" 
                :limitNums="1"
                limitSuffix=".jpg,.jpeg,.png,.webp" 
                :limitWidth="[600, 0]"
                :limitHeight="[600, 0]"
                :limitSize="5 * 1024 * 1024"
                :aspectRatio="1"
                :aspectRatioText="'1:1'"
                :isCheckImg="false"
            />
            <div style="font-size:12px;color:#ccc;">图片要求：比例1:1，不小于600*600，小于5M，仅支持jpg、jpeg、png格式</div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item 
            label="上架设置:" 
            prop="isOnshelf"
            :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
              <el-radio-group v-model="self_form.isOnshelf">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="2">放入草稿箱</el-radio>
              </el-radio-group>
          </el-form-item>
        </div>
      </section>
    </el-form>
    <ProductTitleStandard v-model="productTitleStandardVisible" />
  </div>
</template>
<script>
import "@/assets/css/prod.scss";
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import ImgUpload from "@/components/Uploads/ImgUpload";
import BrandIdBlock from './components/BrandIdBlock.vue';
import ShopCategories from './components/ShopCategories.vue';
import CategoryInput from "../PlatformCategoryInput/index.vue";
import JdmsSpecification from './components/JdmsSpecification.vue';
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import ImageBlock from './components/ImageBlock.vue';
import Attributes from './components/Attributes/index.vue'
import ProductTitleStandard from './components/ProductTitleStandard.vue'
import RULES from "./rules.js";
import {editor_mixin} from '@/components/Editor/index.js'
import {specification_mixin} from '../FormItemSpecification'
import shopListMixin from '../shopListMixin';
import validateMixin from '../validateMixin';
import { cloneDeep } from "lodash";
import dayjs from 'dayjs'

import {
  getjdmsReturnSpecCategoryPropsValue,
  getJdmsCategoryProps,
  getJdmsSalePropRule,
  getJdmsSpecCategoryProps,
} from '@/servers/prod/center/jdms.js'
import {mapGetters, mapActions} from 'vuex'

export default {
  mixins: [specification_mixin, validateMixin,editor_mixin, shopListMixin],
  provide() {
    return {
      noSpPic: true,
      disabledSpName: true,
      platform: "jdms",
      $parent: this,
    }
  },
  inject: {
    isGroupPuhuo: {
      form: 'isGroupPuhuo',
      default: false
    },
    isBatchCategory: {
      from: 'isBatchCategory',
      default: false
    },
  },
  components: {
    MutiImgUpload,
    ImgUpload,
    CategoryInput,
    BrandIdBlock,
    ShopCategories,
    JdmsSpecification,
    GroupImagesList,
    ImageBlock,
    Attributes,
    ProductTitleStandard,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    shopsList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    baseItemId: [Number, String],
    changeToBase: Function,
  },
  data() {
    return {
      isJd: true,
      platform: "jdms",
      self_form: {},
      rules: RULES(this),
      skuPropList: [],
      skuSpecificationsKey: 'skuSpecifications',
      showGroupImages: true,
      orgImagesMap: null, // 原始商品图片集合
      imagesMap: {}, // 商品图片集合

      brandIdOptions: [], // 品牌选项列表
      shops: [], // 店铺id及名称数组
      skuPromiseConfList: [],
      isOnshelf: 1,
      specSkuImage: [],

      attributeList:[], // 属性列表
      salePropList:[], // 销售属性列表
      specAttrList:[], // 特殊属性
      specAttrMap:[], // 特殊属性map对象
      specAttrCheckList:[], // 特殊属性选中的值
      returnPropsList:[],// 退货标签
      productTitleStandardVisible: false,
      titleExampleData:[
        {
          rule:'示例1',
          brand:'伊犁',
          subBrand:'安慕希',
          name:'酸奶',
          description:'草莓味',
          spec:'205g*6瓶/组'
        },
        {
          rule:'示例2',
          brand:'农夫山泉',
          subBrand:'',
          name:'天然饮用水',
          description:'',
          spec:'205g*6瓶*2/组'
        },
        {
          rule:'示例3',
          brand:'',
          subBrand:'',
          name:'富士苹果',
          description:'',
          spec:'205g*6瓶/组'
        },
      ],
      aa:[],
      originalBrandList: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
      originalShopCategories: null, // 原始店内分类配置（用于保存时恢复未显示店铺的数据）
    };
  },
  computed: {
    ...mapGetters(['shops_getCategoryPropShopId']),
    shopList() {
      return this.getShopList('jdms');
    },
    categoryId() {
      return this.getCategoryId()
    },
    skuTableCols() {
      return [
        { prop: 'skuPrice', attrs: { label: 'SKU价格(元)'},input:{type: 'number',onlyTable: false} },
        {prop: 'weight', attrs: {label: '毛重(kg)'},input:{type: 'number',onlyTable: false}},
        {prop: 'outerSkuId', attrs: {label: '商家SKU编码'},input:{type: 'text',onlyTable: true}},
        // {prop: 'skuProp', attrs: {label: 'SKU类目属性',noRequired:true},slot: true, headerSlot: true, unvisible: false},
        {prop: 'upcCode', attrs: {label: '条形码',noRequired:true},input:{type: 'text',onlyTable: true}},
      ]
    },
    mainSku(){
      let list = Object.keys(this.imagesMap);
      return list
    }
  },
  watch: {
    form: {
      handler(v) {
        if (v.skuList) {
          const { specifications = [] } = v;
          // 按照外层的specifications 排序
          v.skuList = v.skuList.map(item => {
            const newSkuSpecifications = [];
            specifications.forEach(spec => {
              const matchItem = item[this.skuSpecificationsKey].find(skuSpec => {
                return skuSpec.nameKey === spec.nameKey;
              });
              if (matchItem) {
                newSkuSpecifications.push(matchItem);
              }
            });
            const _skuid = newSkuSpecifications.map(sp => sp.valueKey).join('-')
            return {
              ...item,
              _skuid
            }
          })
        }
        let brandList = [];
        let shopCategories = [];
        let categoryAttrs = [];
        let categorySpecAttrs = [];
        try{
          brandList = JSON.parse(v.brandList || '[]')
          shopCategories = JSON.parse(v.shopCategories || '[]')
          categoryAttrs = JSON.parse(v.categoryAttrs || '[]')
          categorySpecAttrs = JSON.parse(v.categorySpecAttrs || '[]')
        }catch(e){}
        // 保存原始品牌和店内分类配置，用于保存时恢复未显示店铺的数据
        if (v.brandList) {
          this.$set(this, 'originalBrandList', cloneDeep(brandList));
        }
        if (v.shopCategories) {
          this.$set(this, 'originalShopCategories', cloneDeep(shopCategories));
        }
        if(!v.images || v.images.length === 0){
          v.images = [{
            colorId:'0000000000',
            imageUrls:[]
          }]
        }
        let orgImgMap = {};
        v.images.forEach(item => {
          orgImgMap[item.colorId] = item.imageUrls
        });
        let _specAttrCheckList = categorySpecAttrs.map(item => item.key)
        let _form = {
          ...v,
          isShowProductDesc: v.productDesc ? 1 : 0,
          shopCategories: shopCategories || [],
          registImage:[v.registImage],
          brandList,
          categoryAttrs,
          prdType:v.prdType || 0
        }
        let sloganTime = [];
        sloganTime.push(v.sloganStartTime || '')
        sloganTime.push(v.sloganEndTime || '')
        _form.sloganTime = sloganTime;
        this.$set(this, 'self_form', _form)
        this.$set(this, 'orgImagesMap', orgImgMap)
        this.$set(this, 'imagesMap', orgImgMap)
        this.$set(this, 'specAttrCheckList', _specAttrCheckList)
      },
      immediate: true
    },
    "self_form.categoryIds": {
      handler(v) {
        this.getReturnSpecCategoryPropsValue();
        this.getCategoryProps();
        this.getSpecCategoryProps();
        if(this.self_form.prdType === 1){
          this.getSalePropRule();
        }
      },
      immediate: true
    },
    'self_form.prdType':{
      handler(v) {
        if(v === 1 && this.salePropList.length === 0){
          this.getSalePropRule();
        }
      },
    },
    specifications:{
      handler(v) {
        let images = this.self_form?.images || [];
        let map = {
          '0000000000':images[0]?.imageUrls || []
        }
        let mainSku = v[0]?.values || [];
        mainSku.forEach(item => {
          if(this.orgImagesMap[item.value]){
             map[item.value] = this.orgImagesMap[item.value]
          }else{
            if(map[item.value]){
              if(map[item.value][0] !== item.imageUrl){
                map[item.value][0] = item.imageUrl
              }
            }else{
              map[item.value] = [item.imageUrl]
            }
          }
        })
        this.$set(this, 'imagesMap', map);
      },
      immediate: true
    },
  },
  methods: {
    ...mapActions(['SetDefaultSearchImageList']),
    async valid_form() {
      return new Promise(async (resolve) => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        if(this.self_form.prdType === 0){ // 按sku模式不需要 校验规格明细
          resolve(true);
          return;
        }
        if (this.$refs.jdmsSpecificationRef) {
          const specificationValid = await this.$refs.jdmsSpecificationRef.validate();
          if (!specificationValid) {
              resolve(false);
              return;
          }
        }
        const specificationsValid = this.validateSpecifications();
        this.specificationsValidResult = specificationsValid;
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        const skuPropsValid = this.valid_skuProp();
        if (skuPropsValid !== true) {
          this.specificationsValidResult = skuPropsValid;
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    // 校验sku属性
    valid_skuProp() {
      const skuList = this.skuList || []
      const requiredAttrs = this.skuPropList.filter(item => item.isRequired)
      let isValid = true
      requiredAttrs.forEach(item => {
        skuList.forEach(sku => {
          const skuPropValues = sku.skuPropValues || []
          const findVal = skuPropValues.find(propValue => propValue.attrId === item.id && (propValue.attrValues || []).filter(Boolean).length)
          if(!findVal) {
            isValid = 'SKU属性必填项没有填写！'
            return
          }
        })
      })
      return isValid
    },
      
    method_getFormData(cb) {
      return new Promise(async (resolve, reject) => {
        // 先校验图片
        this.validPage().then((valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resolve(false)
            return;
          }
          const [specifications, skuList] = this.getSpecificationData()
          const attrData = this.$refs.attributesRef.getAttrData();
          let images = [];
          for(let k in this.imagesMap){
            let obj = {
              colorId: k,
              imageUrls: this.imagesMap[k] || []
            };
            images.push(obj)
          }
          let categorySpecAttrs = []
          let _specAttrMap = this.specAttrMap
          this.specAttrCheckList.forEach(key => {
            let obj = {
                key,
                valueName:_specAttrMap[key].valueName,
            }
            categorySpecAttrs.push(obj)
          })
          let _formdata = {
            ...this.self_form,
            specifications,
            skuList,
            images,
            categoryId:this.categoryId
          }

          _formdata.brandList = JSON.stringify(this.mergeHiddenShopData(cloneDeep(_formdata.brandList), this.originalBrandList, this.shopList));
          _formdata.shopCategories = JSON.stringify(this.mergeHiddenShopData(cloneDeep(_formdata.shopCategories), this.originalShopCategories, this.shopList));
          _formdata.categoryAttrs = JSON.stringify(attrData);
          _formdata.categorySpecAttrs = JSON.stringify(categorySpecAttrs);
          if(_formdata.sloganTime && _formdata.sloganTime.length > 0){
              if(_formdata.sloganTime[0]){
                _formdata.sloganStartTime = dayjs(_formdata.sloganTime[0]).format('YYYY-MM-DD HH:mm:ss')
              }
              if(_formdata.sloganTime[1]){
                _formdata.sloganEndTime = dayjs(_formdata.sloganTime[1]).format('YYYY-MM-DD HH:mm:ss')
              }
          }
          if(_formdata.approvalTime){
            _formdata.approvalTime = dayjs(_formdata.approvalTime).format('YYYY-MM-DD HH:mm:ss')
          }
          if(_formdata.approvalEndTime){
            _formdata.approvalEndTime = dayjs(_formdata.approvalEndTime).format('YYYY-MM-DD HH:mm:ss')
          }
          if(_formdata.registImage){
            _formdata.registImage = _formdata.registImage[0]
          }
          delete _formdata.sloganTime
          console.log('_formdata:',_formdata)
          resolve(_formdata)
        }).catch(() => {
          resolve(false)
        })
      })
    },
    updateCategoryIds(ids) {
      this.self_form.categoryIds = ids;
    },
    imageUpload(v) {
      const { valueKey, imageUrl } = v || {}
      const curRef = this.$refs['IB-'+valueKey]
      if(imageUrl && curRef) {
        let [imageUrls] = curRef[0].getData()
        imageUrls[0] = imageUrl
        curRef[0].setData([imageUrls])
      }
    },
    // 一键追加到所有sku图(需过滤重复图)
    pushSkuImg() {
      const [imageUrls, imageUrl] = this.$refs['IB-0000000000'][0].getData()
      this.mainSku.forEach((sku) => {
        if (sku === '0000000000') return;
        const [skuImageUrls] = this.$refs['IB-'+sku][0].getData()
        const filterImgs = imageUrls.filter(img => !skuImageUrls.includes(img))
        const concatImgs = [...skuImageUrls, ...filterImgs].slice(0, 10)
        this.setSkuImg(sku, [concatImgs, imageUrl])
      })
    },
    // 覆盖所有sku图片
    coverSkuImg() {
      const [imageUrls, imageUrl] = this.$refs['IB-0000000000'][0].getData()
      this.mainSku.forEach((sku) => {
        if (sku === '0000000000') return;
        this.setSkuImg(sku, [imageUrls, imageUrl])
      })
    },
    // 应用商品图片
    applyMainImg(colorId) {
      const [imageUrls, imageUrl] = this.$refs['IB-0000000000'][0].getData()
      this.setSkuImg(colorId, [imageUrls, imageUrl])
    },
    setSkuImg(colorId, imgs) {
      if (colorId === '0000000000' || !this.$refs['IB-'+colorId]) return;
      let [imageUrls] = imgs;
      this.$refs['IB-'+colorId][0].setData(imgs)
      this.updateSkuImg(colorId, imageUrls)
    },
    updateSkuImg(colorId, imageUrls) {
      this.specifications.forEach(sp => {
        sp.values.forEach(spv => {
          if (spv.valueKey == colorId) {
            spv.imageUrl = imageUrls[0]
            window.__spcificationImg_changed = colorId; 
          }
        })
      })
    },
    imageBlockChange(colorId) {
      const [imageUrls] = this.$refs['IB-'+colorId][0].getData();
      this.$set(this.imagesMap,colorId,imageUrls)
      this.validPage()
    },

    getCategoryId() {
      let categoryIds = this.self_form?.categoryIds
      if(!categoryIds?.length) return ''
      // let categoryId = categoryIds.length > 3 ? categoryIds[2] : categoryIds[categoryIds.length - 1];
      let categoryId = categoryIds[categoryIds.length - 1];
      return categoryId
    },
    editSkuCateprops(row = {}, isBatch) {
      const that = this
      this.$refs.SkuCategoryPropDialogRef.method_open({
        row: cloneDeep(row),
        categoryIds: this.self_form.categoryIds,
        sureFn(newRow) {
          if (isBatch) {
            that.skuList.forEach(sku => {
              sku.skuPropValues = newRow.skuPropValues;
            })
          } else {
            row.skuPropValues = newRow.skuPropValues;
          }
          that.specificationsFieldChanged()
        }
      });
    },
    // 初始化规格相关数据需要在选择类目后
    initSp(saleAttrs){
      let ori_specifications = this.self_form.specifications;
      let _specifications = [];
      if(saleAttrs && saleAttrs.length>0){
        let matchIndex = [];
        saleAttrs.forEach(item => {
          let _valueObj = {
            checked: true,
            imageUrl: "",
            name: item.saleAttrName,
            nameKey: item.saleAttrName,
            value: "",
            valueKey: ""
          }
          let obj = {
             checked:true,
             name:item.saleAttrName,
             nameKey:item.saleAttrName,
             id:item.saleAttrDicId,
             structured:false,
             values:[{..._valueObj}],
          }
          let o = ori_specifications.find(s => s.name.includes(obj.name) || obj.name.includes(s.name))
          let o_index = ori_specifications.find(s => s.name.includes(obj.name) || obj.name.includes(s.name))
          if(o){
            obj.values = o.values
            matchIndex.push(o_index)
          }else{
            // 匹配不到的就按顺序填充
            let len = ori_specifications.length;
            for(let i=0; i<len; i++){
              if(!matchIndex.includes(i)){
                obj.values = ori_specifications[i].values;
                matchIndex.push(i)
                break;
              }
            }
          }
          _specifications.push(obj)
        });
      }
      this.specifications = _specifications
    },
    // 获取商品属性
    async getCategoryProps(){
      let shopId = this.shops_getCategoryPropShopId('jdms')
      let categoryId = this.categoryId
      if(!categoryId || !shopId){
        return
      }
      let res = await getJdmsCategoryProps(shopId,categoryId)
      if(res){
        this.attributeList = res;
      }
    },
    // 获取销售属性
    async getSalePropRule(){
      let shopId = this.shops_getCategoryPropShopId('jdms')
      let categoryId = this.categoryId
      if(!categoryId || !shopId){
        return
      }
      let res = await getJdmsSalePropRule(shopId,categoryId)
      if(res){
        this.salePropList = res;
        this.initSp(res);
      }
    },
    // 获取退货标签
    async getReturnSpecCategoryPropsValue(){
      let shopId = this.shops_getCategoryPropShopId('jdms')
      let categoryId = this.categoryId
      if(!shopId || !categoryId){
        return
      }
      let res = await getjdmsReturnSpecCategoryPropsValue(shopId,categoryId)
      if(res){
        let list = res.skuSpecialAttrValues
        this.$set(this,'returnPropsList',list)
      }
    },
    // 获取特殊属性
    async getSpecCategoryProps(){
      let shopId = this.shops_getCategoryPropShopId('jdms')
      let categoryId = this.categoryId
      if(!shopId || !categoryId){
        return
      }
      let res = await getJdmsSpecCategoryProps(shopId,categoryId,12)
      if(res){
        let list = res.skuSpecialAttrValues || []
        let map = {};
        list.forEach(item => {
          map[item.key] = item
        })
        this.$set(this,'specAttrList',list)
        this.$set(this,'specAttrMap',map)
      }
    },
  },
  created() {
  },
  mounted() {
  },
  unmounted() {
  },
};
</script>

<style lang="scss" scoped>
.gray-block {
  background: #F9F9FA;
  padding: 10px;
}
.brandIdWrap {
  font-size: 12px;
  .brandIdItem + .brandIdItem {
    margin-top: 8px;
  }
}
.number-input {
  & ::v-deep input {
    text-align: left;
  }
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>